<div class="no-entry-content">
    <div class="title">
        <img [src]="exclaimIcon" alt="Exclamation" class="exclaim-icon">
        Direct Access Restricted
    </div>
    <div class="no-entry-text">You can't open the application from here</div>
    <div class="suggestion-text">Please log in to DHD Application to access IOA PulseAgent</div>
</div>
